export const productName = 'WINE STUDIES & OENOLOGY TEACHER READY';
export const productShortName = 'Wine Studies & Oenology Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/gCwJhAZatvYAtxAUZXEPR5/MOCKUP_10.59.57_a._m..png';

export const checkoutUrl = 'https://wine-studies-oenology-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Foundations of Wine & Oenology',
  'Volume 2 — Viticulture: From Vine to Grape',
  'Volume 3 — Winemaking Science & Production',
  'Volume 4 — Wine Aging, Cellaring & Development',
  'Volume 5 — Sensory Analysis & Wine Tasting',
  'Volume 6 — Wine Regions, Styles & Global Production',
  'Volume 7 — History, Culture & Society of Wine',
  'Volume 8 — Wine Service, Food Pairing & Hospitality',
  'Volume 9 — Teaching Wine Studies & Oenology',
  'Bonus 1 — 150 Classroom Activities & Challenges',
  'Bonus 2 — Assessment Bank',
  'Bonus 3 — 50 Projects & Inquiry-Based Learning',
  'Bonus 4 — Wine Terminology & Concept Handbook',
  'Bonus 5 — 100 Case Studies & Real-World Scenarios',
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex wine concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see wine studies' relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
